import { Box, Stack } from '@mui/material'
import { PageHeader, PageHeaderProps } from 'components/core/page-header'
import { FC } from 'react'

type C1DrawerInnerProps = {
    children: React.ReactNode
}

type C1DrawerInnerHeaderProps = {
    children: React.ReactNode
} & Omit<PageHeaderProps, 'title' | 'padded'>

type C1DrawerInnerContentProps = {
    children: React.ReactNode
}

type C1DrawerInnerFooterProps = {
    children: React.ReactNode
}

const C1DrawerInner: FC<C1DrawerInnerProps> & {
    Header: FC<C1DrawerInnerHeaderProps>;
    Content: FC<C1DrawerInnerContentProps>;
    Footer: FC<C1DrawerInnerFooterProps>;
} = ({ children }) => (
    <Stack sx={{ height: '100vh', justifyContent: 'space-between' }}>
        {children}
    </Stack>
)

const Header: FC<C1DrawerInnerHeaderProps> = ({ children, ...props }) => (
    <PageHeader title={children} padded {...props} />
)

const Content: FC<C1DrawerInnerContentProps> = ({ children }) => (
    <Box
        sx={{
            ...{ flexGrow: 1, overflowY: 'auto', p: 4, px: 5 },
        }}
        role="region"
    >
        {children}
    </Box>
)

const Footer: FC<C1DrawerInnerFooterProps> = ({ children }) => (
    <Stack spacing={4} sx={{ p: 4, borderTop: '1px solid', borderTopColor: 'divider', backgroundColor: 'background.default' }}>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
            {children}
        </Stack>
    </Stack>
)

C1DrawerInner.Header = Header
C1DrawerInner.Content = Content
C1DrawerInner.Footer = Footer

export { C1DrawerInner }
